import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { FileDTEResponse, FileDetailResponse } from 'src/app/models/admin.model';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { AdminDTEService } from 'src/app/services/admin.service';

@Component({
  selector: 'app-upload-new-dte',
  templateUrl: './upload-new-dte.component.html',
  styleUrls: ['./upload-new-dte.component.scss']
})
export class UploadNewDteComponent implements OnInit {
  anulable = false;
  inputFile = new InputAutocompleteModel("", false, false, "", "fa-asterisk", "text-danger", "", [], []);
  file: File | null = null;
  files: FileDTEResponse[] = [];
  filterFiles: FileDTEResponse[] = [];
  fileSelected: FileDetailResponse = null;
  buttonSave: ButtonLoading = new ButtonLoading("btn-success", false, "PROCESAR SELECCIONADOS", "fa-save");
  buttonPreview: ButtonLoading = new ButtonLoading("btn-info", false, "PREVISUALIZAR", "fa-eye");
  buttonProcess: ButtonLoading = new ButtonLoading("btn-success", false, "PROCESAR", "fa-upload");
  @ViewChild('file') fileInput: ElementRef;

  constructor(
    private toastService: ToastrService,
    private adminService: AdminDTEService
  ) {
    for (let i = 0; i < 4; i++) {
      this.inputFile.filterElements.push({ name: "Nombre de prueba " + i, emisor: i * 432, receptor: i * 175 });
    }
  }

  ngOnInit(): void {

  }

  onFileChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.files?.length) {
      this.file = inputElement.files[0];
    }
  }

  preview() {
    if (this.file) {
      if (this.buttonPreview.loading) {
        return;
      }
      this.buttonPreview.loading = true;
      this.adminService.previewFile(this.file).subscribe({
        next: (response: ResponseObject) => {
          this.files = response.data.files as FileDTEResponse[];
          this.filterFiles = this.files;
          this.buttonPreview.loading = false;
        },
        error: (error: HttpErrorResponse) => {
          this.buttonPreview.loading = false;
          this.toastService.error(error.error.message);
        }
      })
    } else {
      this.toastService.error("Elige un archivo primero");
    }
  }

  process() {
    if (this.file) {
      if (this.buttonProcess.loading) {
        return;
      }
      this.buttonProcess.loading = true;
      this.adminService.processFile(this.file, this.anulable).subscribe({
        next: (response: any) => {
          this.buttonProcess.loading = false;
          if(this.anulable == false){
            this.refresh();
            this.toastService.success("Su documento fue enviado a la cola");
          }else{
            if (response.data.totalFailed == 0) {
              this.refresh();
              this.toastService.success("Se procesó correctamente el documento");
            } else {
              this.toastService.error("Se falló en procesar " + response.data.totalFailed + " documento(s)");
            }
          }
        },
        error: (error: HttpErrorResponse) => {
          this.buttonProcess.loading = false;
          this.toastService.error(error.error.message);
        }
      })
    } else {
      this.toastService.error("Elige un archivo primero");
    }
  }

  searchFile() {
    this.filterFiles = this.files.filter((file) => {
      var file_lowcase = this.inputFile.value.toLowerCase();
      return !file_lowcase || file.fileName.toLowerCase().includes(file_lowcase) || file.nitEmisor.toLowerCase().includes(file_lowcase)
        || file.nitReceptor.toLowerCase().includes(file_lowcase);
    });
    if (this.filterFiles.length > 0) {
      this.inputFile.class = "fa-list";
    } else {
      this.inputFile.class = "fa-xmark";
    }
  }

  selectFile(file: FileDTEResponse) {
    this.inputFile.value = file.fileName;
    this.inputFile.class = "fa-circle-check";
    this.inputFile.verified = true;
    this.adminService.getFile(file.fileName).subscribe({
      next: (response: ResponseObject) => {
        this.fileSelected = response.data;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }


  processSelected() {
    if (this.buttonSave.loading) {
      return;
    }
    this.buttonSave.loading = true;
    this.adminService.processSelected(this.fileSelected, this.anulable).subscribe({
      next: (response: ResponseObject) => {
        this.buttonSave.loading = false;
        if (response.data.totalFailed == 0) {
          this.toastService.success("Se procesó correctamente el documento");
          this.refresh();
        } else {
          this.toastService.error("Se falló en procesar " + response.data.totalFailed + " documento(s)");
        }
      },
      error: (error: HttpErrorResponse) => {
        this.buttonSave.loading = false;
        this.toastService.error(error.error.message);
      }
    })
  }

  refresh(): void {
    this.anulable = false;
    this.inputFile = new InputAutocompleteModel("", false, false, "", "fa-asterisk", "text-danger", "", [], []);
    this.file = null;
    this.files = [];
    this.filterFiles = [];
    this.fileSelected = null;
    this.buttonSave = new ButtonLoading("btn-success", false, "PROCESAR SELECCIONADOS", "fa-save");
    this.buttonPreview = new ButtonLoading("btn-info", false, "PREVISUALIZAR", "fa-eye");
    this.buttonProcess = new ButtonLoading("btn-success", false, "PROCESAR", "fa-upload");
    this.fileInput.nativeElement.value = '';
  }
}
